import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import { Icon } from 'antd';
import _notification from 'modules/notification';
import { Card } from 'antd';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import FileUpload from '../../components/controls/FileUpload';
import ButtonComponent from 'components/controls/Button';
// import xls from '../../assets/template/StudentResultData.xlsx';
import xls from '../../assets/template/CenterBatchLabCountData.xlsx';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';


class UploadCenterBatchLabCountData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            uploadedDoc: "",
            fileError: "",
            loading: false,
            uploadErrorMessage: ""
        };
    }

    componentDidMount() {

    }

    handleUpload = async (input) => {
        if (this.state.uploadedDoc && this.state.fileError == "") {
            try {
                this.setState({ loading: true }, async () => {
                    try {
                        var formData = new FormData()
                        formData.append('file', this.state.uploadedDoc)

                        //console.log("Form data: ", formData);

                        const response = await _AdminService.ImportCenterBatchLabCountData(formData);
                        //console.log("Upload File response: ", response);
                        if (response.status == 200 && response.data.IsSuccess == true) {
                            _notification.showMessage('success', "File uploaded successfully.");
                            this.setState({
                                uploadedDoc: "",
                                fileError: "",
                                loading: false,
                            });
                        }
                        else {

                            let responseMessage = response.data.Message;
                            this.setState({
                                loading: false,
                                uploadErrorMessage: responseMessage
                            });

                            if (responseMessage == "" || responseMessage == null || responseMessage == undefined) {
                                _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                            }

                        }
                    } catch (e) {
                        // TODO
                        this.setState({ loading: false });
                        console.log('Error: ', e);
                        _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                    }
                });
            } catch (e) { }
        } else {
            _notification.showMessage('error', "Select file to upload");
        }
    }

    onFileDrop = (file) => {
        //console.log(file);
        this.setState({ uploadedDoc: file, fileError: '', uploadErrorMessage: "" });
    }

    onFileError = (errorMsg) => {
        console.log(errorMsg);
        this.setState({ fileError: errorMsg })
    }


    render() {

        if (this.state.loading)
            return <LoadingSpinner/>

        return (

            <div className="container-fluid p-3">
                <PageHeader
                    title="Upload Center Batch Lab Count Data"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Attendance' }, { label: 'Upload Center Batch Lab Count Data' }]}
                />
                <div style={{ textAlign: 'right' }}>
                    <div className="max1200 m-auto mb-2">
                        <div className="d-flex align-items-center justify-content-end">
                            <a className="button-global button-border addbutton autoWidth d-inline-block text-center autoHeight mb-3 d-flex align-items-center justify-content-center"
                                href={xls}  download="CenterBatchLabCountData.xlsx" ><Icon type="download" className="mr-2 font1rem" /> Download Template</a>
                        </div>
                    </div>
                </div>
                <div className="max1200 m-auto">
                    <div className="ent-panel">
                        <h4 className="heading4">Upload Center Batch Lab Count Data file</h4>
                        <div className="admin-inner-wrap p-3">

                            <div className="mb-2 col-sm-12 uploadCard">
                                <FileUpload onFileDrop={this.onFileDrop} onError={this.onFileError} />
                                {this.state.fileError ? <label className="textAlignCenter  "><span className="color-red">Error: {this.state.fileError}</span></label> : <></>}
                            </div>
                            {this.state.uploadErrorMessage != "" ?
                                <Card className="mb-2 col-sm-12 pb-3 uploadErrorMsgAlign">
                                    {this.state.uploadErrorMessage != "" ?
                                        <span className='color-red' dangerouslySetInnerHTML={{ __html: this.state.uploadErrorMessage }}></span> :
                                        <></>}
                                </Card>
                                :
                                <></>
                            }
                        </div>
                        <div className="pt-4 buttonAlignCenter" >
                            <ButtonComponent type="button" value="Upload File" onClick={this.handleUpload} className="button-global button-primary autoHeight small" disabled={this.state.uploadErrorMessage != "" || this.state.loading} />
                        </div>
                    </div>
                </div>
            </div>

        )
    };
}

export default UploadCenterBatchLabCountData;